import { useInfiniteQuery } from '@tanstack/react-query';
import type {
  AgentApiCandidateChatCommentsIndex,
  CandidateChatCommentSourceType,
} from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

type Request = {
  id: number;
  sourceType?: CandidateChatCommentSourceType;
};

export default function useFetchCandidateChatComments({ id, sourceType }: Request) {
  return useInfiniteQuery({
    queryKey: ['candidateChatComments', id, sourceType ?? 'all'],
    queryFn: async ({ pageParam }) => {
      const params = new URLSearchParams({ page: String(pageParam) });
      if (sourceType) params.set('source_type', sourceType);

      return fetchJson<AgentApiCandidateChatCommentsIndex>(
        `/agent/api/candidate_profiles/${id}/candidate_chat_comments.json?${params.toString()}`
      );
    },
    getNextPageParam: (lastPage) => (lastPage.is_last_page ? undefined : lastPage.next_page),
    initialPageParam: 1,
  });
}
